"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=stock-batch.dto.js.map